var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    { staticClass: "pb-10 mangerJob bg-white px-8" },
    [
      _c(
        "LoadingOverlay",
        {
          attrs: {
            hasData: !!_vm.postings,
            loading: _vm.$apollo.queries.postings.loading,
          },
        },
        [
          _vm.isEmpty
            ? _c(
                "EmptyListPlaceholder",
                {
                  attrs: { title: _vm.emptyListTitle },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "image",
                        fn: function () {
                          return [_c("EmptyListImagePosting")]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    446318279
                  ),
                },
                [
                  _c(
                    "div",
                    { staticClass: "flex py-6" },
                    [
                      _c("UiButtonMessage", {
                        attrs: {
                          label: "add black",
                          buttonClass: "customAdd",
                          buttonText: "Add posting",
                        },
                        on: { click: _vm.showNewPostingModal },
                      }),
                    ],
                    1
                  ),
                ]
              )
            : _c(
                "div",
                {},
                [
                  _c("div", [
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex flex-row justify-between items-center",
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "flex font-400 labelWidth leading-6 text-primary-black text-lg",
                          },
                          [
                            _vm._v(" Current job postings "),
                            _vm.postings && _vm.totalPostings > 0
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "text-gray-new text-base font-normal text-sm ml-0.5",
                                  },
                                  [
                                    _vm._v(
                                      "(" + _vm._s(_vm.totalPostings) + ")"
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "flex py-6" },
                          [
                            _c("UiButtonMessage", {
                              attrs: {
                                label: "add black",
                                buttonClass: "customAdd",
                              },
                              on: { click: _vm.showNewPostingModal },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]),
                  _c("div", { staticClass: "table-container" }, [
                    _c(
                      "table",
                      {
                        staticClass:
                          "relative w-full text-sm font-normal text-left dark:text-gray-400",
                      },
                      [
                        _c(
                          "thead",
                          {
                            staticClass:
                              "text-m text-black bg-light-green customBackground",
                          },
                          [
                            _c("tr", [
                              _c(
                                "th",
                                {
                                  staticClass: "py-4 text-sm relative pl-4",
                                  staticStyle: { width: "15%" },
                                  attrs: { scope: "col" },
                                },
                                [
                                  _vm._v(" Title "),
                                  _c("span", {
                                    staticClass:
                                      "right-border px-4 absolute right-4",
                                  }),
                                ]
                              ),
                              _c(
                                "th",
                                {
                                  staticClass: "py-4 text-sm relative",
                                  staticStyle: { width: "15%" },
                                  attrs: { scope: "col" },
                                },
                                [
                                  _vm._v(" Location "),
                                  _c("span", {
                                    staticClass:
                                      "right-border px-4 absolute right-4",
                                  }),
                                ]
                              ),
                              _c(
                                "th",
                                {
                                  staticClass: "py-4 text-sm relative",
                                  staticStyle: { width: "15%" },
                                  attrs: { scope: "col" },
                                },
                                [
                                  _vm._v(" Skills required "),
                                  _c("span", {
                                    staticClass:
                                      "right-border px-4 absolute right-4",
                                  }),
                                ]
                              ),
                              _c(
                                "th",
                                {
                                  staticClass: "py-4 text-sm relative",
                                  staticStyle: { width: "15%" },
                                  attrs: { scope: "col" },
                                },
                                [
                                  _vm._v(" Number of applicants "),
                                  _c("span", {
                                    staticClass:
                                      "right-border px-4 absolute right-4",
                                  }),
                                ]
                              ),
                              _c(
                                "th",
                                {
                                  staticClass: "py-4 text-sm relative",
                                  staticStyle: { width: "10%" },
                                  attrs: { scope: "col" },
                                },
                                [
                                  _vm._v(" Date posted "),
                                  _c("span", {
                                    staticClass:
                                      "right-border px-4 absolute right-4",
                                  }),
                                ]
                              ),
                              _c(
                                "th",
                                {
                                  staticClass: "py-4 text-sm relative",
                                  staticStyle: { width: "10%" },
                                  attrs: { scope: "col" },
                                },
                                [
                                  _vm._v(" Type "),
                                  _c("span", {
                                    staticClass:
                                      "right-border px-4 absolute right-4",
                                  }),
                                ]
                              ),
                              _c(
                                "th",
                                {
                                  staticClass: "py-4 text-sm relative",
                                  staticStyle: { width: "10%" },
                                  attrs: { scope: "col" },
                                },
                                [
                                  _vm._v(" Status "),
                                  _c("span", {
                                    staticClass:
                                      "right-border px-4 absolute right-4",
                                  }),
                                ]
                              ),
                              _c(
                                "th",
                                {
                                  staticClass: "px-2 py-4 text-sm",
                                  staticStyle: { width: "10%" },
                                  attrs: { scope: "col" },
                                },
                                [_vm._v(" Posted At ")]
                              ),
                            ]),
                          ]
                        ),
                        _vm._l(_vm.postings, function (posting) {
                          return _c("PostingCard", {
                            key: posting.id,
                            attrs: {
                              posting: posting,
                              companyId: _vm.companyId,
                              managerId: _vm.managerId,
                            },
                          })
                        }),
                      ],
                      2
                    ),
                  ]),
                  _c("CardPagination", {
                    attrs: { config: _vm.paginationConfig },
                    on: {
                      "update:config": function ($event) {
                        _vm.paginationConfig = $event
                      },
                    },
                  }),
                ],
                1
              ),
        ],
        1
      ),
      _vm.postingModalShown
        ? _c("PostingModal", {
            attrs: { companyId: _vm.companyId, managerId: _vm.managerId },
            model: {
              value: _vm.postingModalShown,
              callback: function ($$v) {
                _vm.postingModalShown = $$v
              },
              expression: "postingModalShown",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }